import {DEFAULT_VALUE_SUMMARY} from "../InstancesConfiguration/InstancesConfiguration";
import PRICES from "../../../../shared/prices";

const EMPTY_VALUE = '–';

const getHostingSum = ({ hostingPlan }) => {
  return {
    value: hostingPlan ? `$${PRICES['hostingPlan'][hostingPlan]}` : null,
    rawPrice: PRICES['hostingPlan'][hostingPlan] || 0
  };
};

const getSetupFeeSum = ({ hostingPlan, urlType }, t) => {
  return {
    value: `$ ${(PRICES.setupFee[hostingPlan] || 0) + (PRICES['urlType'][urlType] || 0)}`,
    rawPrice: (PRICES.setupFee[hostingPlan] || 0) + (PRICES['urlType'][urlType] || 0)
  };
};

const updateInstancesDescriptions = (summary, props) => {
  const { setInstancesDescription } = props;
  const descriptions = {};
  summary.forEach(({ id, data }) => {
    const instanceDescription = data.reduce(
      (acc, { value }) =>
        value && value !== DEFAULT_VALUE_SUMMARY
          ? acc.push(value) && acc
          : acc,
      []
    );
    descriptions[id] = instanceDescription.join(', ');
  });

  setInstancesDescription(descriptions);
  return descriptions;
};


const getIntegrationDriverSum = data => {
  let value = EMPTY_VALUE;
  let rawPrice = 0;
  if (data && data.integrationDriver) {
    value = `$${PRICES.integrationDriver}`;
    rawPrice = PRICES.integrationDriver;
  }
  return { value, rawPrice };
};

const getDhis2SupportPlanSum = (data, props) => {
  const { t } = props;
  let value = EMPTY_VALUE;
  let rawPrice = 0;
  if (data && data.dhis2SupportPlan) {
    value = `$${PRICES.dhis2SupportPlan} x ${data.dhis2SupportPlan} ${t(
      'hourAbbreviation'
    )}`;
    rawPrice = Number(data.dhis2SupportPlan) * PRICES.dhis2SupportPlan;
  }
  return { value, rawPrice };
};


const updateInstancesSummary = (instances, props, state) => {
  const { t } = props;
  const { options } = state;
  const summary = [];
  Object.keys(instances)
    .filter(id => id !== 'instancesSetup')
    .forEach(instanceId => {
      const instance = instances[instanceId];
      const instanceFields = Object.keys(instance);
      const hostingSum = getHostingSum(instance);
      const setupFeeSum = getSetupFeeSum(instance, t);

      const instanceSummary = {
        id: instanceId,
        type: 'instance',
        title: `Instance #${instanceId}`,
        total: hostingSum.rawPrice + setupFeeSum.rawPrice,
        data: [
          {
            label: t(`dhisVersion.summaryLabel`),
            value:
              options['dhisVersion'][instance['dhisVersion']] ||
              DEFAULT_VALUE_SUMMARY
          },
          {
            label: t(`instancePurpose.summaryLabel`),
            value:
              options['instancePurpose'][instance['instancePurpose']] ||
              DEFAULT_VALUE_SUMMARY
          },
          instance['urlType'] === '1'
            ? {
              label: t(`url.summaryLabel`),
              value: instance['url'] || DEFAULT_VALUE_SUMMARY
            }
            : {},
          {
            label: t(`hostingPlan.summaryLabel`),
            value:
              options['hostingPlan'][instance['hostingPlan']] ||
              DEFAULT_VALUE_SUMMARY
          },
          {
            multiLine: true,
            label: t(`regions.summaryLabel`),
            value:
              instanceFields
                .reduce(
                  (acc, field) =>
                    field.startsWith(`regions.`) && !!instance[field]
                      ? acc.push(t(`${field}.label`)) && acc
                      : acc,
                  []
                )
                .join(', ') || DEFAULT_VALUE_SUMMARY
          },
          {
            type: 'bold',
            values: [
              {
                label: t('sums.hosting.summaryLabel'),
                value: hostingSum.value || DEFAULT_VALUE_SUMMARY,
                per: hostingSum.value ? ` / ${t('month')}` : ''
              },
              {
                label: t('sums.setupFee.summaryLabel'),
                value: setupFeeSum.value || DEFAULT_VALUE_SUMMARY,
                per: setupFeeSum.value ? ` / ${t('once')}` : ''
              }
            ]
          }
        ]
      };
      summary.push(instanceSummary);
    });

  return {
    summary,
    descriptions: updateInstancesDescriptions(summary, props)
  };
};

const updateAddOnsSummary = ({name, value}, props) => {
  const { t, formData: { addOns:data } } = props;
  const newData = { ...data, [name]: value };
  const integrationDriverSum = getIntegrationDriverSum(newData);
  const dhis2SupportPlanSum = getDhis2SupportPlanSum(newData, props);
  const dhis2SupportPlanValue =
    dhis2SupportPlanSum.value !== EMPTY_VALUE
      ? {
        label: t('dhis2SupportPlan.summaryLabel'),
        value: '$0'
      }
      : null;
  const integrationDriverValue =
    integrationDriverSum.value !== EMPTY_VALUE
      ? {
        label: t('integrationDriver.summaryLabel'),
        value: integrationDriverSum.value,
        per: ' / month'
      }
      : null;

  const domainValue = newData.domain ? {
    label: t('domain'),
    value: `$${newData.domain}`,
    per: ' / year'
  } : null;

  const summaryData = [domainValue,integrationDriverValue, dhis2SupportPlanValue].filter(Boolean);
  const hasItems = summaryData.length > 0;

  return [
    {
      type: 'addOn',
      title: t('addOns'),
      total: integrationDriverSum.rawPrice + dhis2SupportPlanSum.rawPrice,
      data: hasItems ? [
        {
          type: 'bold',
          removeTopPadding: true,
          values: summaryData
        }
      ] : null
    }
  ];
};


export {
  updateInstancesSummary,
  updateAddOnsSummary
}
